var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"map"}}),_c('div',{staticClass:"left-panel"},[(_vm.visible)?_c('Detail',{attrs:{"detail":_vm.detail},on:{"cancel":_vm.cancel,"trace":_vm.trace}}):_vm._e(),(_vm.companyVisible)?_c('CompanyDetail',{attrs:{"detail":_vm.companyDetail},on:{"cancel":_vm.cancelCompany}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }